import type { ObjectBase } from './objectBase.interface'

export enum SubscriptionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum SubscriptionKind {
  PayPal = 'PayPal',
  TossPayments = 'TossPayments',
  Coupon = 'Coupon',
  Free = 'Free'
}

export interface Subscription<
  User = string,
  Item = string,
  Billing = string,
  Order = string
> {
  _id: string
  user: User
  status: SubscriptionStatus
  currentItem: Item
  billing?: Billing
  expiredAt: Date
  orders: Order[]
  reserveId?: string
  reserveItem?: Item
  executeAt?: Date
  createdAt: Date
}

export interface SubscriptionV2<
  User = string,
  Item = string,
  Order = string
> extends ObjectBase {
  // @ApiObjectId({ required: true, nullable: false })
  user: User
  // @ApiEnum(SubscriptionKind, { required: true, nullable: false })
  kind: SubscriptionKind
  // @ApiEnum(SubscriptionStatus, { required: true, nullable: false })
  status: SubscriptionStatus
  // @ApiObjectId({ required: true, nullable: false })
  item: Item
  // @ApiObjectId({ required: true, nullable: false })
  order: Order
  // @ApiBoolean({ required: true, nullable: false })
  enableSubscription: boolean
  // @ApiDate({ required: false, nullable: true })
  expiredAt: Date
}
